import { useMemo } from "react";
import * as IconPaths from "../../../_static/icons/icon-paths";
import { IconNames } from "../types";

const useIconList = () =>
  useMemo(() => Object.keys(IconPaths) as IconNames[], []);

export default useIconList;
